import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import "../../Assets/CSS/Styles.scss";
import { API_BASE_URL } from '../../config';
const API_URL = `${API_BASE_URL}/uploads`;
const CaseStudies = () => {
  const [caseStudies, setCaseStudies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCaseStudies = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/blogs/type/case-study`)
        setCaseStudies(response.data);
        setLoading(false);
      }
      catch (err) {
        console.error("Error fetching case studies:", err);
        setCaseStudies([]); // fallback to empty
        setLoading(false);
      }
    };

    fetchCaseStudies();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return isNaN(date) ? 'Unknown date' : date.toLocaleDateString();
  };

  if (loading) return <p className="text-center py-20">Loading case studies...</p>;
  if (error) return <p className="text-center py-20 text-red-500">{error}</p>;

  return (
    <div>
      <div className="container mx-auto px-6 py-12 max-w-7xl mt60">
        <div className="mb-12">
          <p className="text-[18px] mb-2 text-gray-700 font-ui">Category</p>
          <h1 className="text-5xl md:text-6xl font-heading text-[#FBBF24]">Case Studies</h1>
        </div>

        {/*  */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {caseStudies.length === 0 ? (
            <div className="col-span-full text-center py-20 bg-white rounded-lg shadow-md">
              <h3 className="text-2xl font-bold text-gray-700 mb-4">
                No Case Studies Available
              </h3>
              <p className="text-gray-500">
                We're preparing some powerful success stories. Stay tuned!
              </p>
            </div>
          ) : (
            caseStudies.map((caseStudy) => (
              // keep your existing card code here
              <div
                key={caseStudy._id}
                className="bg-white rounded-lg shadow-md overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-lg flex flex-col"
                style={{ height: '460px', minHeight: '460px' }}
              >
                <div className="w-full h-48 overflow-hidden flex-shrink-0">
                  <img
                    src={`${API_URL}/${caseStudy.image}`}
                    alt={caseStudy.title || 'Case study image'}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="p-6 flex flex-col flex-grow">
                  <div className="flex items-center text-gray-700 font-ui text-sm mb-4 space-x-4 flex-shrink-0">
                    <div className="flex items-center space-x-2">
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M8 7V3m8 4V3m-9 8h.01M12 11h.01M15 11h.01M7 16h.01M12 16h.01M15 16h.01M18 6H6a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2z"
                        ></path>
                      </svg>
                      <span>{formatDate(caseStudy.publishDate)}</span>
                    </div>

                    {caseStudy.author && (
                      <div>
                        <span>Author: </span>
                        <span className="font-semibold">{caseStudy.author}</span>
                      </div>
                    )}
                  </div>

                  <h3 className="font-heading mb-1 text-[25px] font-bold text-gray-900 flex-shrink-0">
                    {caseStudy.title}
                  </h3>
                  {caseStudy.overview && (
                    <p className="text-[15px] mb-1 text-gray-700 font-ui flex-grow overflow-hidden"
                      style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2, // show max 3 lines of overview
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}>
                      {caseStudy.overview}
                    </p>
                  )}

                  <p
                    className="text-[15px] mb-2 text-gray-700 font-ui flex-grow overflow-hidden"
                    style={{
                      display: '-webkit-box',
                      WebkitLineClamp: 4,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {caseStudy.shortDescription}
                  </p>

                  <Link
                    to={`/case-studies/${caseStudy._id}`}
                    className="text-[#5B42F3] font-ui font-semibold flex items-center  hover:underline flex-shrink-0"
                  >
                    Read More
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                    </svg>
                  </Link>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/* Bottom Call to Action */}
      <section className="bg-blue-900 text-white py-16">
        <div className="container mx-auto text-center px-6 max-w-4xl">
          <h2 className="font-heading font-bold mb-4 text-[30px]">
            Enjoyed the blog? Let's build something great together.
          </h2>
          <p className="text-[18px] font-ui mb-8">
            Ready to transform your institution with cutting-edge ERP solutions?
          </p>
          <Link to="/freedemo" className="inline-block">
            <button className="bg-[#F59E0B] hover:bg-[#f3b541] text-[#0b1120] px-6 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2">
              Book Free Demo
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default CaseStudies;
